import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
import usuario from './usuario/sagas';

export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    usuario(),
  ]);
}
